import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// 翻譯資源
const resources = {
  zh: {
    translation: {
      // 導航
      home: '首頁',
      about: '關於公司',
      portfolio: '作品集',
      contact: '聯絡我們',
      
      // 首頁
      welcome: '歡迎來到凱撒數位科技',
      slogan: '創新科技，卓越服務',
      learnMore: '了解更多',
      ourServices: '我們的服務',
      
      // 關於
      aboutUs: '關於我們',
      aboutDesc: '凱撒數位科技（CaesarTechStudio）成立於2023年，是一家專注於提供數位化解決方案的科技公司。我們擁有一支經驗豐富的專業團隊，致力於為客戶創造最具價值的數位體驗。',
      ourMission: '我們的使命',
      missionDesc: '以創新科技為客戶創造獨特的數位體驗，推動企業數位轉型。',
      ourVision: '我們的願景',
      visionDesc: '成為亞太地區領先的數位科技服務提供商，引領產業數位化發展。',
      
      // 作品集
      recentWorks: '近期作品',
      viewMore: '查看更多',
      
      // 聯絡
      getInTouch: '與我們聯繫',
      address: '地址',
      phone: '電話',
      email: '電子郵件',
      sendMessage: '發送訊息',
      yourName: '您的姓名',
      yourEmail: '您的電子郵件',
      subject: '主旨',
      message: '訊息',
      send: '發送',
      
      // 頁腳
      copyright: ' © 凱撒數位科技股份有限公司 CaesarTechStudio. 版權所有。Copyright ©',
      allRights: ''
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'zh', // 預設語言
    interpolation: {
      escapeValue: false // React 已經處理 XSS 問題
    }
  });

export default i18n; 